import React, {useEffect} from 'react';
import { motion } from 'framer-motion';

import Transition from '../assets/Transition';
import Header from '../components/Header';
import ContactForm from "../components/ContactForm";
import About from "../components/About";

import Image from '../assets/contact.webp';

const Contact = () => {
    useEffect(() => {
        document.title = "Contact Me";
    });

    return (
        <motion.div
            initial={{translateX: 50, opacity: 0}}
            animate={{translateX: 0, opacity: 1}}
            exit={{translateX: 50, opacity: 0}}
            transition={{duration: 0.6, ease: [0.43, 0.13, 0.23, 0.96]}}>
            <Header
                title="Let's Connect"
                tagline={<>Interested in working together, hiring me, or discussing a project? <span className='underline'>I'd love to hear from you</span>.</>}
                image={Image}
                subtitle="ZOTY"/>
            <About />
            <ContactForm/>
        </motion.div>
    );
};

export default Transition(Contact);